// import React, { Fragment } from 'react'

// import PropTypes from 'prop-types'

// import './hero141.css'

// const Hero141 = (props) => {
//   return (
//     <div className="hero141-container thq-section-padding">
//       <div className="hero141-max-width thq-section-max-width">
//         <div className="hero141-column">
//           <div className="hero141-content">
//             <h1 className="hero141-text1 thq-heading-1">
//               {props.heading1 ?? (
//                 <Fragment>
//                   <span className="hero141-text7">Prop Content</span>
//                 </Fragment>
//               )}
//             </h1>
//             <p className="hero141-text2 thq-body-large">
//               {props.content1 ?? (
//                 <Fragment>
//                   <span className="hero141-text8">Prop Content</span>
//                 </Fragment>
//               )}
//             </p>
//             <div className="hero141-actions">
//               <button className="thq-button-filled hero141-button1">
//                 <a
//                   href="mailto:admin@signbridge.com?subject=Connect to our team"
//                   className="hero141-text3 thq-body-small"
//                 >
//                   {props.action1 ?? (
//                     <Fragment>
//                       <span className="hero141-text5">Contact Us</span>
//                     </Fragment>
//                   )}
//                 </a>
//               </button>
//               <button className="thq-button-outline hero141-button2">
//                 <a
//                   href="tel:2362347381"
//                   className="hero141-text4 thq-body-small"
//                 >
//                   {props.action2 ?? (
//                     <Fragment>
//                       <span className="hero141-text6">Talk to us</span>
//                     </Fragment>
//                   )}
//                 </a>
//               </button>
//             </div>
//           </div>
//         </div>
//         <video
//           src={props.video1Src}
//           loop="true"
//           muted="true"
//           poster={props.video1Poster}
//           autoPlay="true"
//           className="hero141-video thq-img-ratio-4-3"
//         ></video>
//       </div>
//     </div>
//   )
// }

// Hero141.defaultProps = {
//   action1: undefined,
//   video1Src:
//     'https://videos.pexels.com/video-files/7559975/7559975-hd_1080_1920_25fps.mp4',
//   action2: undefined,
//   heading1: undefined,
//   video1Poster:
//     'https://images.pexels.com/videos/7559975/pictures/preview-0.jpeg',
//   content1: undefined,
// }

// Hero141.propTypes = {
//   action1: PropTypes.element,
//   video1Src: PropTypes.string,
//   action2: PropTypes.element,
//   heading1: PropTypes.element,
//   video1Poster: PropTypes.string,
//   content1: PropTypes.element,
// }

// export default Hero141


import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import './hero141.css'

const Hero141 = (props) => {
  return (
    <div className="hero141-container thq-section-padding">
      <div className="hero141-max-width thq-section-max-width">
        <div className="hero141-column">
          <div className="hero141-content">
            <h1 className="hero141-text1 thq-heading-1">
              {props.heading1 ?? (
                <Fragment>
                  <span className="hero141-text7">Prop Content</span>
                </Fragment>
              )}
            </h1>
            <p className="hero141-text2 thq-body-large">
              {props.content1 ?? (
                <Fragment>
                  <span className="hero141-text8">Prop Content</span>
                </Fragment>
              )}
            </p>
            <div className="hero141-actions">
              <button className="thq-button-filled hero141-button1">
                <a
                  href="mailto:admin@signbridge.com?subject=Connect to our team"
                  className="hero141-text3 thq-body-small"
                >
                  {props.action1 ?? (
                    <Fragment>
                      <span className="hero141-text5">Contact Us</span>
                    </Fragment>
                  )}
                </a>
              </button>
              <button className="thq-button-outline hero141-button2">
                <a
                  href="tel:2362347381"
                  className="hero141-text4 thq-body-small"
                >
                  {props.action2 ?? (
                    <Fragment>
                      <span className="hero141-text6">Talk to us</span>
                    </Fragment>
                  )}
                </a>
              </button>
            </div>
          </div>
        </div>
        {/* YouTube视频嵌入 */}
        <iframe
          src="https://www.youtube.com/embed/irVc6iONCFs?autoplay=1&loop=1&playlist=irVc6iONCFs&mute=1"
          className="hero141-video thq-img-ratio-4-3"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Promotional Video"
        />
      </div>
    </div>
  )
}

Hero141.defaultProps = {
  action1: undefined,
  video1Src:
    'https://videos.pexels.com/video-files/7559975/7559975-hd_1080_1920_25fps.mp4',
  action2: undefined,
  heading1: undefined,
  video1Poster:
    'https://images.pexels.com/videos/7559975/pictures/preview-0.jpeg',
  content1: undefined,
}

Hero141.propTypes = {
  action1: PropTypes.element,
  video1Src: PropTypes.string,
  action2: PropTypes.element,
  heading1: PropTypes.element,
  video1Poster: PropTypes.string,
  content1: PropTypes.element,
}

export default Hero141

